var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "13px",
    viewBox: "0 0 8 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vehicle-buy-cash-/-personal-info",
    transform: "translate(-430.000000, -1826.000000)",
    strokeWidth: 2,
    stroke: "#C3092F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(423.000000, 1752.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Rectangle-2",
    transform: "translate(7.949747, 80.449747) rotate(45.000000) translate(-7.949747, -80.449747) ",
    points: "4.44974747 76.9497475 4.44974747 76.9497475 11.4497475 76.9497475 11.4497475 83.9497475"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonarrow);
export default __webpack_public_path__ + "static/media/buttonarrow.c2740f0efc094425ca581e923dd284bd.svg";
export { ForwardRef as ReactComponent };